"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Reports_style_1 = require("./Reports.style");
const ReportCard = ({ analyticsType }) => {
    return ((0, jsx_runtime_1.jsx)(Reports_style_1.StyledLink, { className: "flex-inline justify-space-between width-100 p-m", to: `/admin/reporty/${analyticsType}`, children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col", children: [(0, jsx_runtime_1.jsx)(Reports_style_1.ReportCardTitle, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `admin.analytics.${analyticsType}.title` }) }), (0, jsx_runtime_1.jsx)(Reports_style_1.ReportCardDescription, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `admin.analytics.${analyticsType}.description` }) })] }) }));
};
exports.ReportCard = ReportCard;
